/**
 * TextArea.js
 *
 * Copyright (c) apploft. GmbH
 */
import React from 'react';
import { stringMatching, isRequired } from '../Theme';

function TextArea(_ref) {
  var name = _ref.name,
      props = _ref.props,
      errors = _ref.errors,
      register = _ref.register,
      defaultValue = _ref.defaultValue,
      strings = _ref.strings;
  var required = isRequired(props);
  return React.createElement(React.Fragment, null, React.createElement('label', null, stringMatching(strings, name, required)), React.createElement('textarea', {
    placeholder: props.example,
    defaultValue: defaultValue,
    name: name,
    ref: register({
      required: required
    }),
    rows: '10',
    cols: '80'
  }), errors[name] && React.createElement('p', null, "Please provide valid ".concat(stringMatching(strings, name))));
}

export default TextArea;